/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { EmbeddedMetric } from '../../../shared/surface-cards/EmbeddedMetric'
import { EmbeddedMetricGrid } from '../../../shared/surface-cards/EmbeddedMetricGrid';

type UsageLine = { line: string; value: string; overQuota: boolean } | null;

type Props = {
  branchUsage: UsageLine;
  userUsage: UsageLine;
  /** Etiqueta opcional encima de la fila (p. ej. Perfil). En Billing omitir. */
  title?: string;
  hint?: string;
};

/** Cuotas del plan embebidas en una card de settings. */
export function PlanUsageMetrics({ branchUsage, userUsage, title, hint }: Props) {
  if (!branchUsage && !userUsage) return null;

  return (
    <EmbeddedMetricGrid title={title} hint={hint} dividerTop>
      {branchUsage ? (
        <EmbeddedMetric
          label="Sucursales"
          value={branchUsage.value}
          warning={branchUsage.overQuota}
          progressFromValue
        />
      ) : null}
      {userUsage ? (
        <EmbeddedMetric
          label="Usuarios"
          value={userUsage.value}
          warning={userUsage.overQuota}
          progressFromValue
        />
      ) : null}
    </EmbeddedMetricGrid>
  );
}
